import { apiClient, orgApiPath } from '@/core/api';

export interface AssetStreamingEntry {
  content_url: string;
  thumbnail_url?: string | null;
}

export async function streamingResolveAssets(
  relativeUris: string[],
): Promise<Record<string, AssetStreamingEntry>> {
  const res = await apiClient<{ by_relative_uri: Record<string, AssetStreamingEntry> }>(
    orgApiPath('/assets/streaming-resolve'),
    {
      method: 'POST',
      body: JSON.stringify({ relative_uris: relativeUris }),
    },
  );
  return res.by_relative_uri ?? {};
}
